<template>

    <transition name="fade">
        <div v-if="hasMessage" class="alert" :class="classes">
            <v-close v-if="canClose" :type="type" @click.native="closeAlert" />
            <div class="alert-body">
                <span v-html="markdown" />
            </div>
        </div>
        <div v-else-if="$slots['default']" class="alert" :class="classes">
            <v-close v-if="canClose" :type="type" @click.native="closeAlert" />
            <div class="alert-body">
                <slot></slot>
            </div>
        </div>
    </transition>

</template>

<style lang="scss">

    .alert {
        background-color: $color-white;
        border: none;
        border-radius: 0;
        margin-bottom: 15px;
        overflow: hidden;
        padding: 0;
        position: relative;
        text-align: center;
        width: 100%;
        word-wrap: break-word;

        .alert-body {
            position: relative;
            a {
                opacity: 1;
                text-decoration: underline;
            }
        }

        &.alert-sm .alert-body {
            @include font-regular(12px);
            line-height: 1.4em;
            padding: 15px;
            span, code {
                @include font-regular(12px);
            }
        }
        &.alert-md .alert-body {
            @include font-regular(13px);
            line-height: 1.6em;
            padding: 20px 30px;
            span, code {
                @include font-regular(13px);
            }
        }

        &.alert-info .alert-body {
            background-color: rgb(from $color-text r g b / 5%);
            color: $color-text;
            a, code {
                color: $color-text !important;
            }
        }
        &.alert-danger .alert-body {
            background-color: rgb(from $color-danger r g b / 5%);
            color: $color-danger;
            a, code {
                color: $color-danger !important;
            }
        }
        &.alert-success .alert-body {
            background-color: rgb(from $color-success r g b / 5%);
            color: $color-success;
            a, code {
                color: $color-success !important;
            }
        }

    }

</style>

<script>

import Close from '@cmp/Close';
import { marked } from 'marked';

export default {

    components: {
        'v-close': Close,
    },

    props: {
        payload: {
            type: Object,
            default: null,
        },
        message: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'danger',
        },
        size: {
            type: String,
            default: 'md',
        },
        canClose: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        hasMessage() {
            return this.payload ? this.payload.message : this.message;
        },

        markdown() {
            let markdown = marked.parse(this.payload ? this.payload.message : this.message);
            return markdown.replace(/<p>|<\/p>/g, '');
        },

        classes() {
            let type = this.payload ? this.payload.type : this.type;
            return {
                'alert-info': type === 'info',
                'alert-danger': type === 'danger',
                'alert-success': type === 'success',
                'alert-sm': this.size === 'sm',
                'alert-md': this.size === 'md',
            };
        },

    },

    methods: {

        closeAlert() {
            this.$el.parentNode.removeChild(this.$el);
        }

    },

}

</script>
